export default __webpack_public_path__ + "static/media/ml.3833ddc5.png";